import { QuizQuestion } from "../../shared/types";
import {
  Speed,
  BusinessCenter,
  Code,
  DataObject,
  LocalActivity,
  Analytics,
  Dashboard,
  AutoAwesome,
  Person,
  Groups,
  Business,
  LocationCity,
  AttachMoney,
  CreditCard,
  Diamond,
  TrendingDown,
  Assignment,
  Computer,
  Build,
  Settings,
  Timeline,
  TrendingUp,
  Assessment,
  Security,
  School,
  Policy,
  Explore,
  VerifiedUser,
  HelpOutline,
  Lightbulb,
  CheckCircle,
  Schedule,
  SupportAgent,
  Description,
  MonetizationOn,
  Insights,
  Storage,
  Sync,
  ManageAccounts,
  AccountBalance,
} from "@mui/icons-material";

export const technologyQuestions: QuizQuestion[] = [
  {
    question: "What is your main goal for working with us?",
    options: [
      { text: "Define a clear timeline and milestones for upcoming tech projects", icon: Timeline },
      { text: "Understand how technology can improve your current work processes", icon: TrendingUp },
      { text: "Evaluate your strengths, challenges, and digital capabilities", icon: Assessment },
      { text: "Plan your future technology investments and budget", icon: AccountBalance },
    ],
  },
  {
    question: "Which area would you like to improve most with technology?",
    options: [
      { text: "Making internal operations smoother and less manual", icon: Settings },
      { text: "Providing better experiences for your customers", icon: SupportAgent },
      { text: "Improving decision-making with reliable data", icon: Insights },
      { text: "Reducing costs or avoiding hidden expenses", icon: MonetizationOn },
    ],
  },
  {
    question: "How would you describe your current readiness for new technology?",
    options: [
      { text: "Ready—we already have some systems; just need alignment", icon: CheckCircle },
      { text: "Curious—we're exploring what could be possible", icon: Lightbulb },
      { text: "Cautious—we want proof before making changes", icon: VerifiedUser },
      { text: "Unprepared—we need help knowing where to start", icon: HelpOutline },
    ],
  },
  {
    question: "When it comes to data and reporting, what matters most?",
    options: [
      { text: "Getting clear and easy-to-understand dashboards", icon: Dashboard },
      { text: "Being able to pull reports as needed, anytime", icon: Assessment },
      { text: "Improving accuracy and fewer manual tasks", icon: AutoAwesome },
      { text: "Ensuring privacy, controls, and reliable storage", icon: Security },
    ],
  },
  {
    question: "Which aspect of change is most challenging now?",
    options: [
      { text: "Staff learning to use new tools", icon: School },
      { text: "Aligning new tech with our current processes", icon: Sync },
      { text: "Justifying the cost of new systems", icon: AttachMoney },
      { text: "Managing the overall plan and timeline", icon: ManageAccounts },
    ],
  },
  {
    question: "How do you decide on making tech investments?",
    options: [
      { text: "We invest only when there's a strong business return", icon: TrendingUp },
      { text: "We invest when we see clear improvement opportunities", icon: Lightbulb },
      { text: "We plan based on leadership vision and future goals", icon: Business },
      { text: "We invest to keep up with our industry and competitors", icon: Speed },
    ],
  },
  {
    question: "How important is it that our technology plan aligns with your wider strategy?",
    options: [
      { text: "Very—tech should support our broader business goals", icon: BusinessCenter },
      { text: "Somewhat—help us define those business goals as we go", icon: Assignment },
      { text: "Not urgent—focus on quick, standalone wins first", icon: Speed },
      { text: "We haven't thought about that—need guidance", icon: HelpOutline },
    ],
  },
  {
    question: "After implementation, what type of help would you want most?",
    options: [
      { text: "Regular check-ins to ensure everything stays on track", icon: Schedule },
      { text: "Training sessions so the team can confidently use it", icon: School },
      { text: "Guidance on creating or updating internal policies", icon: Policy },
      { text: "A handover with clear documentation and next steps", icon: Description },
    ],
  },
  {
    question: "What is your budget range for Integration & Connectivity?",
    options: [
      { text: "$0 - $100/MONTH", icon: AttachMoney },
      { text: "$100 - $200/MONTH", icon: CreditCard },
      { text: "$200 - $500/MONTH", icon: Diamond },
      { text: "$500+/MONTH", icon: Business },
    ],
  },
];